var map = {
	"./cn.json": 7184,
	"./cs.json": 863,
	"./da.json": 8223,
	"./de.json": 532,
	"./el.json": 6465,
	"./en.json": 1005,
	"./es.json": 3458,
	"./it.json": 5744,
	"./ja.json": 5723,
	"./pl.json": 5726,
	"./pt.json": 6709,
	"./ru.json": 8809,
	"i18n/locales/cn.json": 7184,
	"i18n/locales/cs.json": 863,
	"i18n/locales/da.json": 8223,
	"i18n/locales/de.json": 532,
	"i18n/locales/el.json": 6465,
	"i18n/locales/en.json": 1005,
	"i18n/locales/es.json": 3458,
	"i18n/locales/it.json": 5744,
	"i18n/locales/ja.json": 5723,
	"i18n/locales/pl.json": 5726,
	"i18n/locales/pt.json": 6709,
	"i18n/locales/ru.json": 8809
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8499;